/* split-hero.js — Split-screen industry scroll section
   Requires GSAP + ScrollTrigger (already loaded via CDN in index.html)
   Called from the inline script after initTemplates() resolves.
*/

var SPLIT_INDUSTRIES = [
    {
        tag: 'Moving industry',
        headline: 'Customers who are ready to book, not just browse.',
        pain: 'Generic sites with no quote form, no trust signals, no local SEO. Losing jobs to bigger names with a better online presence.',
        solution: 'Instant online quoting, suburb-specific landing pages, review integration and a booking flow that converts after hours.',
        deliverables: ['Quote calculator', 'Suburb pages', 'Review widgets', 'SMS confirmation', 'Google Ads ready'],
        stats: [
            { value: '3×', label: 'more enquiries' },
            { value: '68%', label: 'mobile bookings' },
            { value: '<2s', label: 'load time' }
        ],
        navLabel: 'Moving industry',
        icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>'
    },
    {
        tag: 'Creative sector',
        headline: 'A portfolio that feels as good as the work itself.',
        pain: 'Cookie-cutter templates that flatten the work. No way to sell prints, manage exhibition info or accept commissions.',
        solution: 'Full-bleed image layouts, online shop integration, exhibition calendars and commission enquiry flows — all on-brand.',
        deliverables: ['Full-bleed gallery', 'Print shop', 'Exhibition pages', 'Commission form', 'Instagram feed'],
        stats: [
            { value: '4×', label: 'time on site' },
            { value: 'Sales', label: 'online enabled' },
            { value: 'Zero', label: 'template feel' }
        ],
        navLabel: 'Creative sector',
        icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><path d="M21 15l-5-5L5 21"></path></svg>'
    },
    {
        tag: 'Trade & build',
        headline: 'Win more tenders before you pick up the phone.',
        pain: 'Sites that look like brochures from 2012. No project showcases, no credentialing, no quote request flow.',
        solution: 'Project portfolios with before/after photography, licence display, insurance badges and a streamlined quote request.',
        deliverables: ['Project portfolio', 'Quote request form', 'Licence display', 'Review integration', 'Suburb targeting'],
        stats: [
            { value: '2×', label: 'quote requests' },
            { value: '65%', label: 'via mobile' },
            { value: '★4.9', label: 'avg client rating' }
        ],
        navLabel: 'Trade & build',
        icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>'
    },
    {
        tag: 'Education',
        headline: 'Fill your calendar with the right students.',
        pain: 'Relying on word-of-mouth and Facebook. No way for parents to book, see availability or compare subject specialists.',
        solution: 'Tutor profiles, subject-specific pages, live availability calendar, parent-friendly booking and Google My Business integration.',
        deliverables: ['Tutor profiles', 'Booking calendar', 'Subject pages', 'Parent portal', 'Review schema'],
        stats: [
            { value: '80%', label: 'self-serve booking' },
            { value: '2×', label: 'trial conversions' },
            { value: 'Local', label: 'SEO optimised' }
        ],
        navLabel: 'Education',
        icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>'
    },
    {
        tag: 'Online retail',
        headline: 'A Shopify store built to sell, not just display.',
        pain: 'Slow themes, poor mobile UX and a checkout that leaks customers. Product pages that do not tell the brand story.',
        solution: 'Conversion-optimised Shopify build with fast theme, product storytelling, abandoned cart flows and smart search.',
        deliverables: ['Shopify theme', 'Abandoned cart', 'Product storytelling', 'Smart search', 'Analytics setup'],
        stats: [
            { value: '+34%', label: 'conversion rate' },
            { value: '<1.5s', label: 'page load' },
            { value: '99', label: 'Lighthouse score' }
        ],
        navLabel: 'Online retail',
        icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>'
    },
    {
        tag: 'Digital courses',
        headline: 'Scale past 1-on-1 with a platform built for growth.',
        pain: 'Selling courses via PDF links and PayPal. No proper member area, no drip content, no way to build community.',
        solution: 'Course platform integration (Teachable, LearnDash or custom), member portals, sales pages and email automation.',
        deliverables: ['Course platform', 'Member portal', 'Sales pages', 'Email sequences', 'Affiliate system'],
        stats: [
            { value: '60%', label: 'increase enrolments' },
            { value: 'MRR', label: 'monthly recurring' },
            { value: 'Zero', label: 'tech headaches' }
        ],
        navLabel: 'Digital courses',
        icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><path d="M8 21h8"></path><path d="M12 17v4"></path><polygon points="10 8 15 10 10 12 10 8"></polygon></svg>'
    }
];

// Called from index.html inline script after initTemplates() resolves
function initSplitHero() {
    var leftEl = document.getElementById('split-left');
    var rightEl = document.getElementById('split-right');
    var heroEl = document.querySelector('.industries-section');
    var stageEl = document.querySelector('.split-stage');

    if (!leftEl || !rightEl || !heroEl || !stageEl) {
        console.warn('split-hero: required elements not found');
        return;
    }

    /* ── Utility: navigate to a chapter ── */
    function goTo(idx) {
        var clampedIdx = Math.max(0, Math.min(idx, SPLIT_INDUSTRIES.length - 1));
        // Native CSS scroll-behavior: smooth handles the easing; inline:
        // 'nearest' keeps horizontal scrolling within the right panel rather
        // than scrolling the whole page when navigating chapters.
        slides[clampedIdx].scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    }

    /* ── Build LEFT panel ── */
    // Dynamic Icon container
    var iconContainer = document.createElement('div');
    iconContainer.className = 'split-left-icon-container';

    var nameLabel = document.createElement('span');
    nameLabel.className = 'split-left-name';

    var headerDiv = document.createElement('div');
    headerDiv.className = 'split-left-header';
    headerDiv.appendChild(iconContainer);
    headerDiv.appendChild(nameLabel);

    // Progress nav list
    var navList = document.createElement('ul');
    navList.className = 'split-nav-list';
    navList.setAttribute('role', 'list');

    var navItems = [];
    var barFills = [];

    SPLIT_INDUSTRIES.forEach(function (ind, i) {
        var li = document.createElement('li');
        li.className = 'split-nav-item';
        li.setAttribute('role', 'listitem');
        li.setAttribute('title', 'Jump to ' + ind.navLabel);
        li.addEventListener('click', function () { goTo(i); });

        var label = document.createElement('span');
        label.className = 'split-nav-label';
        label.textContent = ind.navLabel;

        var track = document.createElement('div');
        track.className = 'split-nav-bar-track';

        var fill = document.createElement('div');
        fill.className = 'split-nav-bar-fill';

        track.appendChild(fill);
        li.appendChild(label);
        li.appendChild(track);
        navList.appendChild(li);

        navItems.push(li);
        barFills.push(fill);
    });

    // CTA
    var ctaEl = document.createElement('a');
    ctaEl.className = 'split-left-cta';
    ctaEl.href = 'contact.html#service=NewWebsite';
    ctaEl.textContent = 'Start your project';

    leftEl.appendChild(headerDiv);
    leftEl.appendChild(navList);
    leftEl.appendChild(ctaEl);

    /* ── Build RIGHT panel (one slide per industry) ── */
    var slides = [];
    var dotEls = [];

    SPLIT_INDUSTRIES.forEach(function (ind, i) {
        // Build slide
        var slide = document.createElement('div');
        slide.className = 'split-slide';
        slide.setAttribute('aria-label', ind.navLabel + ' industry');

        // Tag pill
        var tagPill = document.createElement('span');
        tagPill.className = 'slide-tag';
        tagPill.textContent = ind.tag;

        // Headline
        var headline = document.createElement('h3');
        headline.className = 'slide-headline';
        headline.textContent = ind.headline;

        // Problem / Solution cards
        var cards = document.createElement('div');
        cards.className = 'slide-cards';

        var painCard = document.createElement('div');
        painCard.className = 'slide-card problem';
        var painLabel = document.createElement('p');
        painLabel.className = 'slide-card-label';
        painLabel.textContent = 'The problem';
        var painBody = document.createElement('p');
        painBody.className = 'slide-card-body';
        painBody.textContent = ind.pain;
        painCard.appendChild(painLabel);
        painCard.appendChild(painBody);

        var solCard = document.createElement('div');
        solCard.className = 'slide-card solution';
        var solLabel = document.createElement('p');
        solLabel.className = 'slide-card-label';
        solLabel.textContent = 'Our solution';
        var solBody = document.createElement('p');
        solBody.className = 'slide-card-body';
        solBody.textContent = ind.solution;
        solCard.appendChild(solLabel);
        solCard.appendChild(solBody);

        cards.appendChild(painCard);
        cards.appendChild(solCard);

        // Deliverable pills
        var delivWrap = document.createElement('div');
        delivWrap.className = 'slide-deliverables';
        var delivLabel = document.createElement('span');
        delivLabel.className = 'slide-deliverables-label';
        delivLabel.textContent = 'Includes:';
        delivWrap.appendChild(delivLabel);
        ind.deliverables.forEach(function (d) {
            var pill = document.createElement('span');
            pill.className = 'slide-pill';
            pill.textContent = d;
            delivWrap.appendChild(pill);
        });

        // Stat cards
        var statsRow = document.createElement('div');
        statsRow.className = 'slide-stats';
        ind.stats.forEach(function (s) {
            var card = document.createElement('div');
            card.className = 'slide-stat';
            var val = document.createElement('span');
            val.className = 'slide-stat-value';
            val.textContent = s.value;
            var lbl = document.createElement('span');
            lbl.className = 'slide-stat-label';
            lbl.textContent = s.label;
            card.appendChild(val);
            card.appendChild(lbl);
            statsRow.appendChild(card);
        });

        // Nav row (prev/next + dots — dots built after all slides)
        var navRow = document.createElement('div');
        navRow.className = 'slide-nav';

        var prevBtn = document.createElement('button');
        prevBtn.className = 'slide-nav-btn';
        prevBtn.setAttribute('aria-label', 'Previous industry');
        prevBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        if (i === 0) prevBtn.disabled = true;
        prevBtn.addEventListener('click', function () { goTo(i - 1); });

        var nextBtn = document.createElement('button');
        nextBtn.className = 'slide-nav-btn';
        nextBtn.setAttribute('aria-label', 'Next industry');
        nextBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        if (i === SPLIT_INDUSTRIES.length - 1) nextBtn.disabled = true;
        nextBtn.addEventListener('click', function () { goTo(i + 1); });

        navRow.appendChild(prevBtn);
        navRow.appendChild(nextBtn);

        // Assemble slide
        slide.appendChild(tagPill);
        slide.appendChild(headline);
        slide.appendChild(cards);
        slide.appendChild(delivWrap);
        slide.appendChild(statsRow);
        slide.appendChild(navRow);

        rightEl.appendChild(slide);
        slides.push(slide);
    });

    /* ── Dot indicators (appended to each slide's nav row) ── */
    slides.forEach(function (slide, i) {
        var navRow = slide.querySelector('.slide-nav');
        if (!navRow) return;

        var dotsWrap = document.createElement('div');
        dotsWrap.className = 'split-dots';

        SPLIT_INDUSTRIES.forEach(function (_, di) {
            var dot = document.createElement('button');
            dot.className = 'split-dot' + (di === i ? ' active' : '');
            dot.setAttribute('aria-label', 'Go to ' + SPLIT_INDUSTRIES[di].navLabel);
            dot.addEventListener('click', function () { goTo(di); });
            dotsWrap.appendChild(dot);
            if (i === 0) dotEls.push(dot); // collect from first slide for sync
        });

        navRow.appendChild(dotsWrap);
    });

    /* Collect all dot groups for syncing */
    var allDotGroups = [];
    slides.forEach(function (slide) {
        var dotsWrap = slide.querySelector('.split-dots');
        if (dotsWrap) allDotGroups.push(dotsWrap.querySelectorAll('.split-dot'));
    });

    /* ── Activate a chapter ── */
    var currentActive = -1;

    function activateChapter(idx) {
        if (idx === currentActive) return;
        currentActive = idx;

        slides.forEach(function (s, si) {
            s.classList.toggle('active', si === idx);
        });

        navItems.forEach(function (item, ni) {
            item.classList.toggle('active', ni === idx);
            if (ni !== idx) barFills[ni].style.width = ni < idx ? '100%' : '0%';
        });

        allDotGroups.forEach(function (group) {
            group.forEach(function (dot, di) {
                dot.classList.toggle('active', di === idx);
            });
        });

        // Update dynamic icon and mobile name label
        if (iconContainer && SPLIT_INDUSTRIES[idx]) {
            iconContainer.innerHTML = SPLIT_INDUSTRIES[idx].icon;
        }
        if (nameLabel && SPLIT_INDUSTRIES[idx]) {
            nameLabel.textContent = SPLIT_INDUSTRIES[idx].navLabel;
        }

        // Alternate the polaroid tilt per industry (desktop only — the CSS
        // transforms live in a min-width media query), matching the skills
        // polaroids' alternating ±4deg.
        if (headerDiv) {
            headerDiv.classList.toggle('tilt-right', idx % 2 === 0);
            headerDiv.classList.toggle('tilt-left', idx % 2 === 1);
        }
    }

    // Show first slide immediately
    activateChapter(0);

    // Native Scroll Driver (Replaces GSAP pin)
    // We use an IntersectionObserver to solidly trigger the active state changes only when a slide dominates the view
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                var idx = slides.indexOf(entry.target);
                if (idx !== -1) activateChapter(idx);
            }
        });
    }, {
        root: rightEl,
        threshold: 0.5 // Change only when the slide is at least 50% visible (snapping ensures it lands fully)
    });

    slides.forEach(function (slide) {
        observer.observe(slide);
    });

    // ── Auto-advance through slides every 5s. Paused while the user is
    //    hovering / interacting with the stage, AND paused while the section
    //    is off-screen (so the goTo()-driven scrollIntoView doesn't yank the
    //    page back when the user has scrolled past). Respects
    //    prefers-reduced-motion.
    var AUTO_ADVANCE_MS = 5000;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoAdvanceTimer = null;
    var autoAdvancePaused = false;
    var sectionInView = true;

    function startAutoAdvance() {
        stopAutoAdvance();
        if (prefersReducedMotion || autoAdvancePaused || !sectionInView) return;
        autoAdvanceTimer = setInterval(function () {
            if (!slides.length || !sectionInView) return;
            var nextIdx = (currentActive + 1) % slides.length;
            goTo(nextIdx);
        }, AUTO_ADVANCE_MS);
    }

    function stopAutoAdvance() {
        if (autoAdvanceTimer !== null) {
            clearInterval(autoAdvanceTimer);
            autoAdvanceTimer = null;
        }
    }

    // Hover / focus / touch pause.
    stageEl.addEventListener('mouseenter', function () { autoAdvancePaused = true; stopAutoAdvance(); });
    stageEl.addEventListener('mouseleave', function () { autoAdvancePaused = false; startAutoAdvance(); });
    stageEl.addEventListener('focusin',    function () { autoAdvancePaused = true; stopAutoAdvance(); });
    stageEl.addEventListener('focusout',   function () { autoAdvancePaused = false; startAutoAdvance(); });
    stageEl.addEventListener('touchstart', function () { autoAdvancePaused = true; stopAutoAdvance(); }, { passive: true });
    stageEl.addEventListener('touchend',   function () { autoAdvancePaused = false; startAutoAdvance(); }, { passive: true });

    // Viewport pause — only auto-advance while the section is visible. Without
    // this, the periodic goTo() would call scrollIntoView and pull the page
    // back to the hero even if the user has scrolled away to read other content.
    if ('IntersectionObserver' in window) {
        var viewportObserver = new IntersectionObserver(function (entries) {
            sectionInView = entries[0].isIntersecting;
            if (sectionInView) startAutoAdvance();
            else stopAutoAdvance();
        }, { threshold: 0.25 });
        viewportObserver.observe(stageEl);
    }

    // Kick off.
    startAutoAdvance();

    // We still use scroll math strictly for driving the visual progress bar fill widths.
    // Horizontal scroll now (left/right swipe between slides) — uses scrollLeft and
    // offsetWidth instead of the previous scrollTop / offsetHeight.
    rightEl.addEventListener('scroll', function () {
        // Reset the auto-advance countdown whenever the user (or our own
        // scrollIntoView) scrolls — so we don't immediately advance after a
        // manual swipe.
        if (autoAdvanceTimer !== null) {
            stopAutoAdvance();
            startAutoAdvance();
        }
        if (!slides.length) return;
        var scrollPos = rightEl.scrollLeft;
        var slideW = slides[0].offsetWidth;
        if (!slideW) return;

        var exactIdx = scrollPos / slideW;
        var baseIdx = Math.max(0, Math.min(Math.floor(exactIdx), slides.length - 1));
        var chapterProgress = exactIdx - baseIdx;

        // Ensure bounds
        if (baseIdx >= slides.length - 1) {
            baseIdx = slides.length - 1;
            chapterProgress = 1;
        }

        // Drive the progress bars directly
        barFills.forEach(function (fill, i) {
            if (i < baseIdx) fill.style.width = '100%';
            else if (i > baseIdx) fill.style.width = '0%';
            else fill.style.width = (chapterProgress * 100) + '%';
        });
    });
}
